import GeneratedResourceShareStore from "./generated/GeneratedResourceShareStore"

class ResourceShareStore extends GeneratedResourceShareStore {

}

export const resourceShareStore = new ResourceShareStore()
